import { MaybeRefOrGetter } from "vue"
import { IGeneralOverviewItem } from "@/repositories/overview.repository"

export const useResultsFilteringByTag = <T extends IGeneralOverviewItem>(
  _results: MaybeRefOrGetter<T[]>,
  options?: { single: boolean }
) => {
  const activeTags = ref<string[]>([])

  const results = computed(() => toValue(_results))

  const filteredResults = computed(() =>
    results.value.filter((item) => activeTags.value.every((tag) => item.tags?.includes(tag)))
  )

  const availableTags = computed(
    () =>
      results.value
        .map((item) => item.tags ?? [])
        .flat()
        .filter((value, index, array) => array.indexOf(value) === index) // only unique values
  )

  const isTagActive = (tag: string) => activeTags.value.includes(tag)

  const toggleActiveTag = (tag: string) => {
    if (activeTags.value.includes(tag)) {
      if (options?.single) {
        activeTags.value = []
      } else {
        activeTags.value = activeTags.value.filter((t) => t !== tag)
      }
    } else {
      if (options?.single) {
        activeTags.value = [tag]
      } else {
        activeTags.value = [...activeTags.value, tag]
      }
    }
  }
  return {
    filteredResults,
    activeTags,
    availableTags,
    isTagActive,
    toggleActiveTag,
  }
}
